import * as signalR from '@microsoft/signalr';
const URL = process.env.REACT_APP_HUB_ADDRESS ?? ''; //or whatever your backend port is

export class Connector {
  private connection: signalR.HubConnection;
  static instance: Connector;

  constructor(hub: string, accessToken: string) {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${URL}/${hub}`, {
        accessTokenFactory: () => accessToken,
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    this.connection.start().catch((err) => console.error(err));
  }

  public listenToEvent = <T>(eventName: string, callback: (params: T) => void) => {
    this.connection.on(eventName, (params: string) => {
      callback(JSON.parse(params));
    });
  };

  public stopListeningToEvent = (eventName: string) => {
    this.connection.off(eventName);
  };

  public static getInstance(hub: string, accessToken: string): Connector {
    if (!Connector.instance) Connector.instance = new Connector(hub, accessToken);
    return Connector.instance;
  }
}

export default Connector.getInstance;
